import { getTooltip, TableCellBase, TableCellText } from '../../Table'
import Text from '../../Text'
import { RentalPortalViewingDateTile } from '../RentalPortalViewingDateTile'

import { getViewingDateCellDateLabel } from './RentalPortalViewingDateCell.utils'

import * as styles from './RentalPortalViewingDateCell.module.css'

function RentalPortalViewingDateCell({
  className = styles.RentalPortalViewingDateCell,
  isFreeSlot,
  locale,
  start,
  timeLabel,
  timezone,
  ...restProps
}) {
  return (
    <TableCellBase {...restProps} className={className}>
      <RentalPortalViewingDateTile isFreeSlot={isFreeSlot} start={start} />
      <div className={styles.stack}>
        <TableCellText
          className={styles.dateLabel}
          tooltip={getTooltip(start, locale, timezone)}
          value={getViewingDateCellDateLabel({ locale, start, timezone })}
        />
        <Text isSecondary className={styles.timeLabel}>
          {timeLabel}
        </Text>
      </div>
    </TableCellBase>
  )
}

export default RentalPortalViewingDateCell
